var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 32,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 32,
  fill: "#2A2A6C",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M30.35 17.67c.006-1.525-1.251-2.183-2.227-2.694C27.505 14.652 27 14.388 27 14c0-.33.32-.68 1-.77a4.5 4.5 0 0 1 2.36.41l.42-2a6.4 6.4 0 0 0-2.24-.41c-2.36 0-4 1.26-4 3.06 0 1.33 1.19 2.07 2.09 2.51s1.25.75 1.24 1.15c0 .62-.74.9-1.43.91a5 5 0 0 1-2.44-.6l-.43 2c.848.33 1.75.497 2.66.49 2.51 0 4.16-1.24 4.17-3.16zm-6.49-6.28-2 9.25h-2.4l2-9.25zm10.06 6 1.26-3.47.73 3.47zm4.89 3.28h-2.22l-.29-1.38h-3.01l-.49 1.38h-2.52l3.59-8.57a1.09 1.09 0 0 1 1-.68h2zm-22.2-.06 3.88-9.25h-2.6l-2.49 6.29-1-5.35a1.12 1.12 0 0 0-1.11-.94H9.22l-.06.27a10 10 0 0 1 2.36.78 1 1 0 0 1 .57.81L14 20.61z",
  clipRule: "evenodd"
})));
export default SvgVisa;